import React from 'react'
import { VisaLogoIcon, MastercardLogoIcon, CardIcon } from '../icons/new'

// Helper function to get the appropriate card logo
const getCardLogo = (cardBrand) => {
    const brand = cardBrand?.toLowerCase()

    switch (brand) {
        case 'visa':
            return <VisaLogoIcon />
        case 'mastercard':
            return <MastercardLogoIcon />
        default:
            return <CardIcon size={48} />
    }
}

const CreditCardDisplay = ({ paymentData }) => (
    <div className="credit-card-widget mb-4" data-aos="fade-up" data-aos-delay="900">
        <div
            className="primary-gradient-card p-5 d-flex flex-column justify-content-between"
        >
            <div className="d-flex justify-content-between align-items-start">
                <div>
                    <h5 className="card-brand-name mb-1">{paymentData.cardBrand.toUpperCase()}</h5>
                    <p className="card-account-type mb-0">Premium Account</p>
                </div>
                <div className="card-brand-logo">{getCardLogo(paymentData.cardBrand)}</div>
            </div>
            <div className="card-number-section">
                <span className="card-number-group">****</span>
                <span className="card-number-group">****</span>
                <span className="card-number-group">****</span>
                <span className="card-number-group">{paymentData.cardLastDigits}</span>
            </div>
            <div className="d-flex align-items-end justify-content-between">
                <div>
                    <p className="card-label mb-1">Card Holder</p>
                    <h6 className="card-value mb-0">
                        {paymentData.firstName} {paymentData.lastName}
                    </h6>
                </div>
                <div className="text-end">
                    <p className="card-label mb-1 text-white">Expire Date</p>
                    <h6 className="card-value mb-0 text-white">
                        {paymentData.cardExpMonth}/{paymentData.cardExpYear}
                    </h6>
                </div>
            </div>
        </div>
    </div>
)

export default CreditCardDisplay
